export default {
  can_not_withdrawal_tip: '当前账号暂未开放提现，请联系管理员',
  delete_account_tip: '如果该账户存在未完成的交易。将继续使用该账户直到交易完成',
  fixed_amount_tip: '每日9点到 10点发起自动提现，如果0点时的可提现余额大于等于该值，会把0点时的可提现余额全部提现',
  delete_last_bank: '账户列表至少保留一个账户',
  delete_auto_withdrawal_bank: '当前账户为自动提现账户，不可删除',
  bill_mch_order_id: '商户内部系统订单号，在生成账单支付的还款码时上传',
  qr_mch_order_id: '商户内部系统订单号，在生成QR时上传',
  bank_transfer_mch_order_id: '商户内部系统订单号，在生成转账支付账号时上传',
  payout_mch_order_id: '商户内部系统订单号，在生成转账支付账号时上传',
  customer_mobile: '客户电话号码',
  ref_no: '客户用于账单支付的还款码',
  account_no: '客户用于转账支付的账号',
  transaction_time: '客户完成支付的时间',
  payment_receipt: '客户提供的付款记录图片',
  qr_link: '二维码收银台页面的链接',
  qr_code_id: '二维码id',
  cs_qr_input: '请至少提供 QR链接 或 QR Code ID 或 商户订单号 中的一个',
  cs_bill_input: '请至少提供 还款码 或 商户订单号 中的一个',
  cs_account_input: '请至少提供 还款码 或 商户订单号 中的一个',
  image_only: '仅支持图片类型',
  single_payment_link: '创建一个链接，向单个银行账户/电子钱包收款',
  batch_payment_link: '填写并上传模板，批量创建链接，向多个银行账户/电子钱包收款',
  email_content: '你可以在发给顾客的邮件中添加留言',
  drag_file_here: '拖拽文件至此, 或',
  latest_template: '最新模板: 新增支付渠道',
  cash_out_amount_enter: '输入提现金额',
  cash_out_account: '该笔资金将会提现至以下银行账户',
  transfert_enter: '选择商户并输入转账金额',
  choose_transaction: '选择交易类型',
  choose_type_and_fill_ticket: '选择支付方式并填写工单详情',
  qr_code_fill_note_1: '注意：请至少提供二维码链接，二维码ID或者商户订单号中的任一项',
  qr_code_fill_note_2: '注意：请至少提供还款码或者商户订单号中的任一项',
  qr_code_fill_note_3: '注意：请至少提供还款码或者商户订单号中的任一项',
  send_money_single_bank_account: '付款给单个银行或电子钱包账户',
  send_money_multipl_bank_accounts: '付款给多个银行或电子钱包账户 (上传表格模板)',
  select_receiving_channel_and_fill_payments_details: '选择收款渠道并填写付款详情',
  download_and_fill_template_batch_payments: '下载并填写模板进行创建批量付款',
  latest_template_updated_supported_payment_channels: '最新模板：新增支付渠道',
  upload_filled_excel_worksheet_template: '上传填写完成的模板',
  upload_filled_excel_using_template_batch_payments: '上传填写完成的最新表格模板进行批量付款，完成上传后可在列表中下载结果报告。',
  drag_here_click_upload: '拖拽文件至此，或点击上传',
  public_key_introduce: '公钥用于支付网关验证商户的加密信息。',
  ip_white_ezpay_introduce: '请联系 Ezpay 团队进行 IP 白名单处理',
  ip_white_aruxpay_introduce: '请联系 Aruxpay 团队进行 IP 白名单处理',
  ip_white_paycools_introduce: '请联系 Paycools 团队进行 IP 白名单处理',
  share_public_key_introduce: '各个国家的应用设置将统一为当前页面的设置，请确认',
  MFA_verification_code_authenticate_user_access:	'请输入MFA验证码进行用户身份认证',
  EMAIL_verification_code_authenticate_user_access:	'请输入邮箱验证码进行用户身份认证',
  manage_details_new_role: '为此新角色进行角色设置',
  following_permission_granted_role: '分配以下权限给角色',
  enter_account_details_new_user: '为此新账户进行账户设置',
  update_your_password_entering_new_one: '更新你的密码',
  do_reset_mfa_verfication_code: '你想重置用户的MFA码吗？',
  do_want_close_access_permission: '是否要禁用此账号？',
  do_want_change_mfa_status: '是否要更改该用户MFA状态?',
  please_upload_latest_template: '请下载最新模板',
  download_filled_template_batch_stores: '下载并填写模板以创建批量店铺',
  latest_template_add_stores: '最新模板：添加店铺',
  upload_excel_add_stores: '使用最新的模板文件上传您填写的 Excel 工作表以添加店铺',
  upload_file_type_zip: '上传文件类型: zip',
  not_yet_generated: '还没生成',
  supplement_notification: '系统检测到您未添加结算账户及补充信息。 请添加银行/电子钱包并提交补充信息。',
  information_wait_review: '资料已提交，正在等待审查',
  supplement_info_results: '补充资料结果',
  pls_submit_it_again: '请重新提交!',
  following_three_situations_cause_fail: '以下三种情况可能会导致交易失败：',
  spaces_in_the_amount: '金额有无效字符。（例如金额中有空格）',
  spaces_in_the_email_address: '电子邮件地址无效。（例如，电子邮件地址中有空格）',
  wallet_account_number_not_start_with_01: '钱包账号不以01开头',
  wallet_account_number_not_start_with_08: '钱包账号不以08开头',
  wallet_account_number_not_start_with_09: '钱包账号不以09开头',
  wallet_account_number_not_start_with_05: '手机号不以5开头',
  wallet_account_number_rule: '手机号不以06、08或09开头',
  ip_input_tips: '多个ip以英文逗号做分割分隔符，支持子网掩码',
  withdraw_tip_less: '50,000 {currency}以下，24小时内到账',
  withdraw_tip_more: '50,000 {currency}以上, T+1日到账',
  withdraw_tip_day: '选择D+1,为每天提现一次；选择D+3,为每3天提现一次',
  withdraw_tip_amount: '50,000 MXN以下, 实时到账; 50,000 MXN以上, T+1日到账',
  withdraw_tip_bank: '通过输入以下详细信息更新您的银行详细信息',
  fee_tip: '服务费将从提现金额中扣除',
  dashboard_balance_question: '收款和分账转入金额可以被提现；其他金额只能用于付款和转账。分账金额在付款和转账时优先扣除。',
  dashboard_balance_number: '可提现余额: ',
  nsds_balance: 'NSDS余额',
  nsds_credit_limit: '授信额度',
  nsds_credit_limit_pending_prefix: '您的授信额度将于明日调整为',
  nsds_credit_limit_pending_suffix: '',
  nsds_credit_recycle_remark: '因授信额度调减而回收的资金',
  enter_verification_delete_account: '请输入验证码才能删除',
  add_up_six_account: '您最多只能添加六个银行账户',
  cash_out_setting_detail: '以下为提现设置详情：',
  select_cash_out_type_and_code: '请选择提现类型',
  enter_bank_accout_detail_add: '输入银行帐户详细信息以在列表中添加帐户',
  delete_the_beneficiary: '是否确认删除收款人',
  agreement_between_tip: '双方的合作合同。要求：',
  document_requirement: '合同要求',
  contract_basic_review_title: '合同形式审查',
  contract_basic_review_1: '1. 合同所列公章栏、法定代表人(负责人)签字(章)栏内容齐全，与合同主体一致;',
  contract_basic_review_2: '2. 盖章、签字清晰;',
  contract_basic_review_3: '3. 多页合同加盖骑缝章;',
  contract_basic_review_4: '4. 签订日期在商户提交该合同日期之前;',
  contract_basic_review_5: '5. 合同在有效期内。',
  contract_entity_title: '合同主体',
  contract_entity_1: '1. 合同主体为我司商户及其供应商;',
  contract_entity_2: '2. 供应商(如为企业)工商注册状态为有效:',
  contract_entity_3: '3. 合同主体均通过黑名单筛查(包括企业主体、法人、受益人及收款国家)',
  contractual_rights_and_obligations_title: '合同权利义务',
  contractual_rights_and_obligations_1: '合同性质应为货物/服务采购，双方权利义务与合同目的一致',
  contract_object_quantity_quality_title: '合同标的、数量、质量',
  contract_object_quantity_quality_1: '1. 采购商品应与客户店铺销售商品类别一致，如店铺无商品陈列，则与历史还原订单商品类别匹配;',
  contract_object_quantity_quality_2: '2. 采购商品的数量合理，与客户店铺销售情况不存在明显矛盾。',
  contract_price_or_compensation_title: '合同价款或报酬',
  contract_price_or_compensation_1: '1. 合同中明确收款方名称及银行账号，且与实际付款账号一致;',
  contract_price_or_compensation_2: '2. 收款方名称应与供应商一致;',
  contract_price_or_compensation_3: '3. 实际付款周期与供应商付款周期一致，如果是框架合同，需提供当期供应商付款的订单或对账单等付款凭证。',
  large_value_beneficiary_remark_tip: '请简要说明双方的业务关系及付款原因',
  whether_to_submit: '是否提交?',
  standard_payment_limit: '单笔限额',
  beneficiary_address_name_exceed_140: '受益人地址与收款人名称字数总和不能超过140',
  customer_manager_complete_amount_same: '交易金额和完成时间需合并查询',
  customer_manager_complete_invocice_same: '单据号和完成时间需合并查询',
  cumulative_amount_refunded_tip: '已成功的退款订单金额总计',
  remaining_refundable_amount_tip: '剩余可退订单金额=原交易金额-累计已退订单金额-等待退款中的金额-退款中的金额',
  refund_tip_1: '本交易暂不支持退款',
  refund_tip_2: '本交易已超出可退款期限',
  refund_tip_3: '本交易已全部退款',
  mfa_status_tips: '建议启用多重身份验证以提高账户安全性',
  shared_application_setting_tips: '如开启，各个国家交易都共用相同的应用设置。',
  click_to_upload: '点击上传',
  click_to_upload_image: '点击上传图片',
  click_to_upload_attach: '点击上传文件(.xlsx)',
  please_enter: '请输入',
  fill_out_ticket_detail: '填写工单详情',
  cash_out_support_local_bank: '仅支持本币银行账户',
  qr_tips: '预估到账金额=充值金额-QR交易手续费金额',
  thai_qr_tips: '预估到账金额=充值金额-Thai QR交易手续费金额',
  share_public_key_empty: '应用配置不能全为空',
  // share_public_key_to_verify: '支付网关将使用相同的应用设置来验证每个国家的交易。',
  share_public_key_to_verify: '相同的应用设置将同步到每个国家。',
  share_public_key_to_update: '是否要更新公钥？',
  share_public_ip_to_update: '是否要更新 IP 白名单',
  share_public_webhook_to_update: '是否要更新 Webhook',
  scan_qr_code_tip: '您可以使用以下应用程序扫描此二维码进行付款',
  qr_code_expires_in: '二维码有效期',
  qr_code_expires: '二维码已过期',
  upload_receipt_tip: '请上传付款账户的相关文件，如银行卡/存折/银行对账单副本等（最多5张图片）。',
  automatic_withdrawal_amount_limit_1: '当商户可提现金额≥',
  automatic_withdrawal_amount_limit_2: '时，才会发起自动提现',
  chillpay_tips: '您充值的金额会在下一个工作日（T+1）当地时间（UTC+7）3:00pm时入账，请知悉',
  proceed_to_payment_tip_1: '请等待风控审核，审核通过后需要在',
  proceed_to_payment_tip_2: '内完成扫码支付流程',
  current_time_zone: '此模块不受时区设置影响，固定为对应国家时区',
  not_bank_account: '您还未添加银行账户 ',
  exchange_rate_update_tip: '汇率5分钟更新一次',
  feature_not_supported_country: '抱歉，您选择的国家暂不支持此功能',
  try_another_country: '您可以尝试选择其他国家来使用此功能',
  nsds_pay_tip: '充值金额小于完全偿付金额',
  customer_manager_complete_account_suffix_same: '付款账户后缀和完成时间需合并查询',
  balance_change_amount_tip: '扣除余额 = 退款订单金额（发起退款的金额） - 退回手续费（当用户承担时为0） + 退款手续费（当用户承担时为0）',
  refund_amount_tip: '退款交易金额 - 退回手续费',
  split_amount_tips: '分账金额 = 分账成功的金额 + 待分账的金额 - 分账退回的金额',
  add_receiver_tips: '您最多只能添加{count}个分账接收方',
  split_receiver_delete_tips: '确认删除该记录吗？',
  split_receiver_upload_tips: '上传文件大小限制在5m以内，支持jpg,jpeg,png,pdf',
  new_cash_out_account: '该笔资金将会提现至以下银行账户,时效 0-5个工作日',
  invalid_withdrawal_amount_arrival: '请输入有效的提现金额，换汇的到账金额需大于0，请检查后重新输入',
  invoice_file_format_error: '请上传PDF、JPEG 、 PNG、Excel 、CSV格式文件',
  please_upload_image: '请上传图片文件',
  please_upload_image_or_pdf: '请上传图片或PDF文件',
  file_size_exceeded: '文件大小不能超过10MB',
  validation_number_only: '请输入数字',
  create_static_qr_tips: '收款用途名称仅限用于区分收款码或对账使用，不支持对于用户收款码名称自定义',
  after_create_static_qr_tips: '  您的静态二维码正在创建中，预计需要1-3分钟时间，创建后可在列表进行二维码下载及查看'
}
